var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.36364 0C1.55083 0 0 1.51251 0 3.33333V5.57692C0 7.52226 1.57427 8.87631 3.2933 8.99752C3.31671 8.99917 3.34017 9 3.36364 9H5.63636C7.44917 9 9 7.48749 9 5.66667V3.33333C9 1.56383 7.59068 0 5.72727 0H3.36364ZM14.3636 0C12.5508 0 11 1.51251 11 3.33333V5.66667C11 7.48749 12.5508 9 14.3636 9H16.6364C18.4492 9 20 7.48749 20 5.66667V3.33333C20 1.56383 18.5907 0 16.7273 0H14.3636ZM3.36364 11C1.55083 11 0 12.5125 0 14.3333V16.6667C0 18.5453 1.59974 19.8781 3.2933 19.9975C3.31671 19.9992 3.34017 20 3.36364 20H5.63636C7.44917 20 9 18.4875 9 16.6667V14.3333C9 12.5638 7.59068 11 5.72727 11H3.36364ZM14.3636 11C12.5508 11 11 12.5125 11 14.3333V16.6667C11 18.4875 12.5508 20 14.3636 20H16.6364C18.4492 20 20 18.4875 20 16.6667V14.3333C20 12.5638 18.5907 11 16.7273 11H14.3636Z",
    fill: "#048A8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.5d37cf7ab24c2a61a83da12f6153742d.svg";
export { ForwardRef as ReactComponent };